import * as React from 'react'
import { Body } from '../../components/templates/Wrappers'
import LoginPageImage from '../../assets/images/login-page-image.jpg'
import colors from '../../globals/colors'
import { IsMobile, IsTablet, useWindowSize } from '../../globals/UIHooks';



export const AuthenticationBody: React.FC<{loading: boolean}> = ({ children, loading }) => {
    const { width } = useWindowSize()
    const gridColumns = IsMobile(width) ? '1fr' : IsTablet(width) ? '1fr 1fr' : '2fr 1fr'

    return (
        <Body loading={loading}>
            <div style={{ display: 'grid', gridTemplateColumns: gridColumns, width: '100%', minHeight: '100vh' }}>
                {!IsMobile(width) && (
                    <div style={{
                        backgroundImage: `url(${LoginPageImage})`, overflow: "none",
                        backgroundSize: 'cover', backgroundPosition: 'top', backgroundColor: colors.darkOpacity,
                    }}>
                    </div>
                )}
                <div style={{ boxShadow: colors.defaultShadow, overflow: 'scroll' }}>
                    <div style={{ padding: 20, maxWidth: 400, marginLeft: 'auto', marginRight: 'auto', width: '80%' }}>
                        {children}
                    </div>
                </div>
            </div>
        </Body>
    )
}
